import Vue from 'vue';
// import XEUtils from 'xe-utils';

import {
  VXETable,
  Table,
  Column,
  Colgroup,
  Icon,
  Grid,
  Tooltip,
} from 'vxe-table';
// console.log(VXETable);
// 按需加载的方式默认是不带国际化的，需要自行导入
// VXETable.setup({
//   i18n: (key, args) => i18n.t(key, args)
// });

Vue.use(Colgroup);
Vue.use(Column);
Vue.use(Tooltip);
Vue.use(Grid);
Vue.use(Icon);

// 再安装核心库
Vue.use(Table);
VXETable.formats.add('formatMoney', ({ cellValue }) => cellValue === '' || cellValue === '-' ? cellValue : Vue.prototype.Helper.formatMoney(cellValue))
// Vue.use(VXETable);

// 给 vue 实例挂载全局窗口对象，例如：
// Vue.prototype.$XModal = VXETable.modal

// 给 vue 实例挂载全局打印对象，例如：
// Vue.prototype.$XPrint = VXETable.print



// WEBPACK FOOTER //
// ./src/common/vxeTableUse.js